export default {
    BASE_URL: '/admin/crm',
    api: [
      {
        name: 'registerList',
        desc: '注册用户列表',
        method: 'GET',
        path: '/user/register_list'
      },
      {
        name: 'resetPassword',
        desc: '重置密码',
        method: 'POST',
        path: '/reset/password'
      },
      {
        name: 'changeMobile',
        desc: '变更安全手机',
        method: 'PUT',
        path: '/update/member/mobile'
      }
    ]
  }


// WEBPACK FOOTER //
// ./src/api/member/register.js